// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exam-description-content-wrapper {\n  width: 600px;\n}\n.exam-description-content-wrapper .el-message-box__content {\n  height: 600px;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
